<div class="base" role="main">
    <div class="skv-box skv-box--compact">
        <h2>Ansökan om legitimation för lärare och förskollärare</h2>
        <label class="text-standard" for="who-desc">Vem gäller ansökan?</label>
        <p id="who-desc">Ansökan om legitimation gäller dig som har en lärarexamen, förskollärarexamen eller en examen inriktad mot fritidshemmet och
          vill ansöka via post. Ansökan gäller både dig som ansöker om legitimation för första gången,
          och dig som redan har en legitimation och ska komplettera den med fler behörigheter.</p>

      <label class="text-standard" for="how-desc">Skicka in din ansökan</label>
      <p id="how-desc">Här kan du som inte har e-legitimation ansöka via post. Använd även post om du har skyddade personuppgifter. Innehåller handlingarna känsliga personuppgifter, exempelvis uppgifter om hälsa, använd i första hand vanlig post.<br/>
        För ansökningar via post skickar du denna till:<br/><br/>

        Skolverket<br/>
        Box 4002<br/>
        171 04 Solna<br/><br/>

        Om du vill ansöka digitalt genom vår e-tjänst ansöker du via denna länk: <a target="blank"
         href="https://lleg.skolverket.se/">Ansökan om legitimation för lärare och förskollärare</a>
      </p>

        <label class="text-standard" for="time-desc">Hur lång tid tar ansökan?</label>
        <p id="time-desc">Ansökan tar mellan 15 och 30 minuter beroende på vad du väljer att ansöka om.
          Du kan inte pausa eller spara din ansökan för att sedan återuppta den igen, se därför till att ha de intyg som krävs för din typ av ansökan redo.
          När du är klar sparas dina uppgifter som en pdf du sedan kan skriva ut och skicka till Skolverket.
        </p>

        <label class="text-standard" for="time-desc2">Vad händer efter att jag ansökt?</label>
        <p id="time-desc2">När Skolverket tagit emot och registrerat din ansökan skickar vi bekräftelse på din ansökan till din digitala brevlåda
          (till exempel KIVRA eller Min myndighetspost) om du har en sådan. Annars kommer bekräftelsen via post till din folkbokförda adress. </p>

        <!--<app-reveal title="Komplettera pågående ansökan">
            <label class="text-standard" for="supplement-desc">Komplettera pågående ansökan</label>
            <p id="supplement-desc">
              Har du redan gjort en ansökan och vill komplettera din ansökan med digitala handlingar?<br/>
              Om du ansökte till och med 28 maj 2024 kan du komplettera <a href="komplettering"><u>här</u></a><br/>
              Om du ansökte från och med 29 maj 2024 kan du komplettera  <a target="blank"
                                                                            href="https://lleg.skolverket.se/">
              <u>här</u></a>
            </p>
        </app-reveal>-->
    </div>
    <div class="skv-box skv-box--compact skv-box--no-border">
        <h2>Påbörja ansökan via post</h2>
        <app-navigation-query [query]="query"></app-navigation-query>
    </div>
</div>
